import { Box, styled } from '@mui/material';
import { FeedbackIconButton } from 'features/feedback';
import { JobApplication, mapSendingStatusToJobStatus } from 'features/myJobs';
import { OfferDescription } from 'pages/candidateOfferList/components';
import ProcessedOfferStatus from 'pages/candidateOfferList/components/OfferDescription/ProcessedOfferStatus';
import { useCallback } from 'react';
import { ContentCard } from 'shared/components';
import { useTenantContext } from 'shared/contexts';

import JobActions from './JobActions';

export interface JobCardProps {
  job: JobApplication;
  onFeedbackClick?: (job: JobApplication) => void;
}

export default function JobListItem({ job, onFeedbackClick }: JobCardProps) {
    const tenant = useTenantContext();

    const handleFeedbackClick = useCallback(() => {
        onFeedbackClick?.(job);
    }, [ onFeedbackClick, job ]);

    const hasRole = Boolean(job.role);
    const status = mapSendingStatusToJobStatus(job.status);
    const feedbackIcon = onFeedbackClick ? <FeedbackIconButton onClick={ handleFeedbackClick } /> : undefined;

    return (
        <ContentCard sx={{ position: 'relative' }}>
            { !hasRole && (
                <Corner>
                    <ProcessedOfferStatus status={ status } />
                    { feedbackIcon }
                </Corner>
            ) }

            <OfferDescription { ...job }
                timeZone={ tenant.timeZone }
                offerType={ job.shifts?.length ? 'Shifts' : 'Weeks' }
                elementsCount={ job.shifts?.length || job.periods?.length || 0 }
                status={ hasRole ? status : undefined }
                headerAdornment={ hasRole ? feedbackIcon : undefined } />
            <JobActions jobId={ job.id } />
        </ContentCard>
    );
}

const Corner = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(5),
    right: theme.spacing(5),
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(1)
}));
